import moment from 'moment';
import {$stateParams } from '../../router';

declare var ga;

const Utils = {};

// Format date
Utils.prettyDate = (date) => {
	if (date) return moment.utc(date).format('MMM Do YYYY [at] HH:mm');
	return '';
};

/**
 * Append width paramater to image url 
 * 
 * @param {String} imageUrl 
 * @param {Number} size 
 
 * @returns {String}
 */
Utils.appendSizeToImageUrl = (imageUrl, size) => {
    if (!imageUrl) return '';
    if (!size || !Number.isInteger(size) || size < 1) return imageUrl;

    return `${imageUrl}?w=${size}`;
}

Utils.formatDate = (date, format) => {
	return moment(date).format(format);
}

export default Utils;